'use strict';

Object.defineProperty(exports, "__esModule", {
            value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _selectorFecha = require('./selector-fecha.directive');

var _selectorFecha2 = _interopRequireDefault(_selectorFecha);

var _separadorMiles = require('./separador-miles.directive');

var _separadorMiles2 = _interopRequireDefault(_separadorMiles);

var _blurConEnter = require('./blur-con-enter.directive');

var _blurConEnter2 = _interopRequireDefault(_blurConEnter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'buscador.directivas';

var ngModule = _angular2.default.module(MODULE_NAME, []);

ngModule.directive('itSelectorFecha', ['fechaConfig', '$timeout', 'utilFactory', function (fechaConfig, $timeout, utilFactory) {
            return new _selectorFecha2.default(fechaConfig, $timeout, utilFactory);
}]).directive('itSeparadorMiles', function () {
            return new _separadorMiles2.default();
}).directive('itBlurConEnter', function () {
            return new _blurConEnter2.default();
});

exports.default = MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/index.js